export default {
  labels: {
    sold_out: 'Ausverkauft!',
    most_popular: '#{{rank}} Beliebtesten',
    last_ordered: 'Zuletzt bestellt',
  },
};
